import { ChangeDetectionStrategy, Component, ContentChild, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppUser } from 'src/app/shared/models/app-user';
import { InsightsLibraryItemSelectorItemActionsDirective } from '../../components/item-selector/item-actions.directive';
import { InsightsLibraryItemSelectorItemDescriptionDirective } from '../../components/item-selector/item-description.directive';
import { InsightsLibraryItemSelectorItemPreviewDirective } from '../../components/item-selector/item-preview.directive';
import { CategorySelectedEvent, ItemSelectedEvent } from '../../components/item-selector/item-selector.component';
import { createItemSelectorActions } from '../../state/item-selector/actions';
import { IItemSelectorCategory, IItemSelectorItem } from '../../state/item-selector/reducer';
import { createItemSelectorSelectors } from '../../state/item-selector/selectors';

@Component({
  selector: 'app-insights-library__item-selector-shell',
  template: `
    <app-insights-library__item-selector
      [user]="user"
      [busy]="busy"

      [categories]="categories$ | async"

      [selectedCategoryIndex]="selectedCategoryIndex$ | async"
      [selectedCategory]="selectedCategory$ | async"
      [selectedCategoryItems]="selectedCategoryItems$ | async"
     
      [selectedItemIndex]="selectedItemIndex$ | async"
      [selectedItem]="selectedItem$ | async"

      [itemActions]="itemActions"
      [itemDescription]="itemDescription"
      [itemPreview]="itemPreview"

      (categorySelected)="categorySelected($event)"
      (itemSelected)="itemSelected($event)"
    ></app-insights-library__item-selector>
  `,
  standalone: false
})
export class InsightsLibraryItemSelectorShellComponent<
  I extends IItemSelectorItem,
  C extends IItemSelectorCategory<I>> implements OnInit {
  @Input() actions: ReturnType<typeof createItemSelectorActions>;
  @Input() selectors: ReturnType<typeof createItemSelectorSelectors>;

  @Input() user: AppUser;
  @Input() busy: boolean;

  categories$: Observable<C[]>;

  selectedCategoryIndex$: Observable<number>;
  selectedCategory$: Observable<C>;
  selectedCategoryItems$: Observable<I[]>;
  
  selectedItemIndex$: Observable<number>;
  selectedItem$: Observable<I>;

  @ContentChild(InsightsLibraryItemSelectorItemActionsDirective)
  itemActions: InsightsLibraryItemSelectorItemActionsDirective;

  @ContentChild(InsightsLibraryItemSelectorItemDescriptionDirective)
  itemDescription: InsightsLibraryItemSelectorItemDescriptionDirective;

  @ContentChild(InsightsLibraryItemSelectorItemPreviewDirective)
  itemPreview: InsightsLibraryItemSelectorItemPreviewDirective;

  constructor(
    public store: Store,
    public router: Router,
    public route: ActivatedRoute) {
  }

  ngOnInit() {
    this.categories$ =
      <any>this.store.pipe(select(this.selectors.categories));


    this.selectedCategoryIndex$ =
      <any>this.store.pipe(select(this.selectors.selectedCategoryIndex));

    this.selectedCategory$ =
      <any>this.store.pipe(select(this.selectors.selectedCategory));

    this.selectedCategoryItems$ =
      <any>this.store.pipe(select(this.selectors.selectedCategoryItems));


    this.selectedItemIndex$ =
      <any>this.store.pipe(select(this.selectors.selectedItemIndex));

    this.selectedItem$ =
      <any>this.store.pipe(select(this.selectors.selectedItem));
  }


  categorySelected(e: CategorySelectedEvent<I, C>) {
    this.store.dispatch(this.actions.setSelectedCategory({
      categoryIndex: e.index
    }));
  }

  itemSelected(e: ItemSelectedEvent<I, C>) {
    this.store.dispatch(this.actions.setSelectedItem({
      itemIndex: e.index
    }));
  }
}
